/** A Polaris field's value from its input or change event. */
export function fieldValue(event: { currentTarget: EventTarget }): string {
  return (event.currentTarget as HTMLInputElement).value;
}
